/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const SortDescriptor = zod.object({
  "field": zod.string(),
  "isDescending": zod.boolean().optional(),
  "order": zod.number().optional()
});

export type SortDescriptor = zod.input<typeof SortDescriptor>;
export type SortDescriptorOutput = zod.output<typeof SortDescriptor>;
